import { render } from "./Balance.vue?vue&type=template&id=389dafdc&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=389dafdc&lang=scss&scoped=true"
import "./Balance.vue?vue&type=style&index=1&id=389dafdc&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389dafdc"]])

export default __exports__